module.exports = __webpack_public_path__ + "static/media/team.9e73df1e.png";